import React, { createContext, useContext, useEffect, useState } from 'react';
import { CustomerModel } from '../types/crm-contact';
import { getAppToken } from '../api/sessions';

// Context oluştur
const CustomerContext = createContext<{
    customers: CustomerModel[];
    setCustomers: React.Dispatch<React.SetStateAction<CustomerModel[]>>;
  }>({ customers: [], setCustomers: () => {} });

  // Context'in değerlerine erişmek için bir hook oluştur
  export const useCustomerContext = () => useContext(CustomerContext);

  // Context'in sağlayıcısı bileşeni
  export const CustomerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [customers, setCustomers] = useState<CustomerModel[]>([]);


    return (
      <CustomerContext.Provider value={{ customers, setCustomers }}>
        {children}
      </CustomerContext.Provider>
    );
  };